Ext.define('SA.data.Sort', {
    singleton: true,

    createAttributeSorter(values, direction) {
        var multiplier = direction === 'asc' ? 1 : -1,
            Attributes = SA.data.AttributesCache,
            typesMap = {
                count: 5,
                percent: 4,
                mean: 3,
                median: 2,
                date: 1
            };

        if (!values) {
            return nameSort;
        }

        return function(id1, id2) {
            var type1 = Attributes.get(id1).type,
                type2 = Attributes.get(id2).type,
                value1 = values[id1],
                value2 = values[id2];

            if (type1 !== type2) {
                return multiplier * (typesMap[type1] - typesMap[type2]);
            }

            if (value1 === value2) {
                return multiplier * nameSort(id1, id2);
            }

            if (value1 == null) {
                return 1;
            }

            if (value2 == null) {
                return -1;
            }

            return multiplier * (value1 - value2);
        };

        function nameSort(id1, id2) {
            var name1 = Attributes.get(id1).name,
                name2 = Attributes.get(id2).name;

            return SA.data.Sort.titleText(name1, name2) * multiplier;
        }
    },

    createLocationSorter(values, direction) {
        var multiplier = direction === 'asc' ? 1 : -1,
            Locations = SA.data.LocationsCache;

        if (!values) {
            return nameSort;
        }

        return function(id1, id2) {
            var value1 = values[id1],
                value2 = values[id2];

            if (value1 === value2) {
                return multiplier * nameSort(id1, id2);
            }

            if (value1 == null) {
                return 1;
            }

            if (value2 == null) {
                return -1;
            }

            return multiplier * (value1 - value2);
        };

        function nameSort(id1, id2) {
            var name1 = Locations.get(id1).name,
                name2 = Locations.get(id2).name;

            return SA.data.Sort.titleText(name1, name2) * multiplier;
        }
    },

    getPrioritySorter({getPriorityIndex, defaultCompare}) {
        return (a, b) => {
            var [indexA, indexB] = [a, b].map(getPriorityIndex),
                [aListed, bListed] = [indexA, indexB].map(index => index >= 0);

            if (aListed && bListed) {
                return indexA < indexB ? -1 : 1;
            }
            else if (!aListed && !bListed) {
                return defaultCompare(a, b);
            }

            return aListed ? -1 : 1; 
        };
    },

    numericByKey(key) {
        return (a, b) => Number(a[key]) - Number(b[key]);
    },

    titleText(text1, text2) {
        var uc1 = (text1 + '').toUpperCase(),
            uc2 = (text2 + '').toUpperCase();

        if (uc1 !== uc2) {
            text1 = uc1;
            text2 = uc2;
        }

        return text1 === text2 ? 0 : text1 < text2 ? -1 : 1;
    }
});